import React, { ReactElement } from 'react';

import { SlidePanel, Loader } from 'ui/patterns';

import { useGetProcedureDetails } from 'hooks';

import { PreviewPanelType } from './linkProcedureTypes';

export default function PreviewPanel({
  previewProcedure,
  closePreviewProcedure,
  selectedIds,
}: PreviewPanelType): ReactElement {
  const { data: procedureDetails, isLoading: isProcedureDetailsLoading } =
    useGetProcedureDetails({
      accountId: selectedIds?.accountId,
      procedureId: selectedIds?.procedureId,
    });

  const createMarkup = () => {
    return { __html: procedureDetails?.Data?.Content || '' };
  };

  return (
    <>
      <SlidePanel
        open={previewProcedure}
        onClose={() => closePreviewProcedure()}
        title={procedureDetails?.Data?.AccountProcedure?.Procedure?.Name}
        size="md"
      >
        <div dangerouslySetInnerHTML={createMarkup()} />
        {isProcedureDetailsLoading && <Loader />}
      </SlidePanel>
    </>
  );
}
